export default "__VITE_ASSET__C7SRzEWW__"